var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2186_40331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2835 8.57143C13.1238 8.57143 15.4263 7.54808 15.4263 6.28571C15.4263 5.02335 13.1238 4 10.2835 4C7.44316 4 5.14062 5.02335 5.14062 6.28571C5.14062 7.54808 7.44316 8.57143 10.2835 8.57143Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14062 6.28125V13.1384C5.14062 14.3955 7.42634 15.4241 10.2835 15.4241C13.1406 15.4241 15.4263 14.3955 15.4263 13.1384V6.28125",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4263 9.71094C15.4263 10.9681 13.1406 11.9967 10.2835 11.9967C7.42634 11.9967 5.14062 10.9681 5.14062 9.71094",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1703 1.7232C8.83487 0.899058 7.2804 0.500475 5.71317 0.580343C2.86746 0.580343 0.570312 1.60892 0.570312 2.86606C0.570312 3.54035 1.23317 4.14606 2.2846 4.58035",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2846 11.4386C1.23317 11.0043 0.570312 10.3986 0.570312 9.72433V2.86719",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2846 8.01116C1.23317 7.57688 0.570312 6.97116 0.570312 6.29688",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2186_40331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.f0e08154b1704aade913bdfbbe4ffc01.svg";
export { ForwardRef as ReactComponent };